import { createSvgIcon } from '@automata/mui-theme';
import HexagonOutlinedIcon from '@mui/icons-material/HexagonOutlined';
export const ConditionIcon = createSvgIcon(
  <HexagonOutlinedIcon />,
  'ConditionIcon'
);
